import axiosInstance from "../../lib/axiosInstance";
import { toast } from "react-toastify";
import { AppDispatch } from "../store";
import { attendanceRecordActions as slice } from "../slices/attendanceRecord";
import { getErrorMessage } from "../../utils/errorUtils";
import { AttendanceBulkRequestDto } from "../../shared/dtos/attendanceRecord/AttendanceBulkRequestDto";
import { AttendanceRosterResponseDto } from "../../shared/dtos/attendanceRecord/AttendanceRosterResponseDto";
import { AttendanceResponseDto } from "../../shared/dtos/attendanceRecord/AttendanceResponseDto";
import { ApiResponseDto } from "../../shared/dtos/common/ApiResponseDto";
import { ApiResponseStatus } from "../../shared/enums/ApiResponseStatus";

export interface AttendanceRosterParams {
  classroomId: string;
  date: string;
  timetableSlotId?: string;
}

export const getAttendanceRecordRoster =
  (params: AttendanceRosterParams) => async (dispatch: AppDispatch) => {
    dispatch(slice.setLoadingRoster());
    try {
      const { data } = await axiosInstance.get<
        ApiResponseDto<AttendanceRosterResponseDto[]>
      >("/attendance-records/roster", {
        headers: { requiresAuth: true },
        params,
      });

      if (data.status === ApiResponseStatus.SUCCESS && data.data) {
        dispatch(slice.setRoster(data.data));
      }
    } catch (error) {
      dispatch(slice.setErrorLoadingRoster(getErrorMessage(error)));
    }
  };

export const saveAttendanceRecordBulk =
  (values: AttendanceBulkRequestDto) => async (dispatch: AppDispatch) => {
    dispatch(slice.setLoadingAttendanceBulk());
    try {
      const { data } = await axiosInstance.post<ApiResponseDto<void>>(
        "/attendance-records/bulk",
        values,
        { headers: { requiresAuth: true } },
      );

      if (data.status === ApiResponseStatus.SUCCESS) {
        toast.success(data.message || "Attendance updated successfully!");
        dispatch(slice.saveBulkSuccess());
        dispatch(
          slice.setServerResponseStatus({
            operation: "bulk-save",
            status: data.statusCode || 201,
          }),
        );
      }
    } catch (error) {
      const message = getErrorMessage(error);
      toast.error(message);
      dispatch(slice.setErrorSavingBulk(message));
    }
  };

export const getAttendanceRecordsByClassroom =
  (params: AttendanceRosterParams) => async (dispatch: AppDispatch) => {
    dispatch(slice.setLoadingAttendanceRecords());
    try {
      const { data } = await axiosInstance.get<
        ApiResponseDto<AttendanceResponseDto[]>
      >("/attendance-records", { headers: { requiresAuth: true }, params });

      if (data.status === ApiResponseStatus.SUCCESS && data.data) {
        dispatch(slice.setAttendanceRecords(data.data));
      }
    } catch (error) {
      toast.error(getErrorMessage(error));
    }
  };

export const deleteAttendanceRecord =
  (id: string) => async (dispatch: AppDispatch) => {
    dispatch(slice.setLoadingAttendanceDelete());
    try {
      const { data } = await axiosInstance.delete<ApiResponseDto<void>>(
        `/attendance-records/${id}`,
        { headers: { requiresAuth: true } },
      );

      if (data.status === ApiResponseStatus.SUCCESS) {
        toast.success(data.message || "Record deleted");
        dispatch(slice.deleteAttendanceSuccess(id));
      }
    } catch (error) {
      toast.error(getErrorMessage(error));
    }
  };

export const resetAttendanceServerStatus = () => (dispatch: AppDispatch) => {
  dispatch(slice.setServerResponseStatus(null));
};
